<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M3171.06 35.31l-2743.8 0c-215.55,0 -391.99,176.37 -391.99,392l0 2743.79c0,215.55 176.37,391.99 391.99,391.99l2743.8 -0.15c215.55,0 391.99,-176.36 391.99,-391.99l-0.07 -2743.72c0,-215.55 -176.37,-391.99 -392,-391.99l0.08 0.07zm0 3135.71l-2743.8 0 0 -2743.79 2743.8 0 0 2743.79zm-2351.81 -1763.88l391.92 0 0 1371.89 -391.92 0 0 -1371.89zm783.91 -587.92l392 0 0 1959.81 -392 0 0 -1959.81zm783.91 1175.9l392 0 0 783.91 -392 0 0 -783.91z"/>
 </g>
</svg>
